/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import ThemeRegistry from "./ThemeRegistry";
import Header from "./global/Header";
import useSubscriptionStore from "./store/subscriptionStore";
export default function RootApplicationLayout(param) {
    let { children } = param;
    const fetchSubscriptionInfo = useSubscriptionStore((state)=>state.fetchSubscriptionInfo);
    useEffect(()=>{
        fetchSubscriptionInfo();
    }, []);
    return /*#__PURE__*/ _jsxs(ThemeRegistry, {
        options: {
            key: "mui"
        },
        children: [
            /*#__PURE__*/ _jsx(Header, {}),
            children
        ]
    });
}
